import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useAuthenticationStore } from '@repo/store/useAuthenticationStore'
import { useNavigate } from 'react-router-dom'

export const RouteGuard = ({ children, protectedRoute = true }) => {
  const { isLoggedIn, setDeepLink } = useAuthenticationStore()
  const navigate = useNavigate()

  useEffect(() => {
    if (protectedRoute && !isLoggedIn) {
      const href = window.location.href

      if (typeof href === 'string') {
        const hashIndex = href.indexOf('#')

        if (hashIndex !== -1) {
          const newPath = href.substring(hashIndex + 1)
          setDeepLink(newPath)
        }
      }
      navigate('/auth/logout')
    }
  }, [protectedRoute, isLoggedIn, navigate, setDeepLink])

  return <>{children}</>
}

RouteGuard.propTypes = {
  children: PropTypes.node,
  protectedRoute: PropTypes.bool
}
